import { render, staticRenderFns } from "./VerticalsSelect.vue?vue&type=template&id=0edf48bc&scoped=true"
import script from "./VerticalsSelect.vue?vue&type=script&lang=ts"
export * from "./VerticalsSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf48bc",
  null
  
)

export default component.exports